import {updateFeatureFormulaColumn} from '../pages/Dashboard/mapping';
import {rerenderFeatures, roundNumber} from './dataHelper';
import {getPrecisionFormat} from './dateTimeHelper';
import moment from 'moment';

const callbacks = [];
const allEventsFromResponse = {};

export const triggerAdditionalDataCb = function (board, triggerFeatureName, featuresNames) {
    if (['product_id', 'summary'].includes(triggerFeatureName.toLowerCase())) {
        calcLTV365ForSummaryTable(board, allEventsFromResponse[board.loadedId]);
        board.allFormulas.forEach((formula, index) => {
            if (formula.isAdditionalColumn || formula.isCurrentFeatureAdditionalColumn) {
                const formulaIndex = index + board.allEvents.length;
                updateFeatureFormulaColumn(board.featuresData, formulaIndex, formula, board.additionalColumnsByFeatureName, board.arppuCoef);
                rerenderFeatures();
            }
        });
    }
    if (featuresNames) {
        featuresNames.forEach((featureName) => {
            const cbObject = callbacks.find((cbSaved) => cbSaved.name === featureName);
            if (cbObject) {
                cbObject.cb();
            }
        });
    }

};

export const listenAdditionalDataCb = function (featureName, cb) {
    if (!callbacks.find((cbSaved) => cbSaved.name === featureName.toLowerCase())) {
        callbacks.push({
            name: featureName.toLowerCase(),
            cb,
        });
    }
};

export const calcLTV365ForSummaryTable = function (currentBoard, eventsFromResponse) {
    const arrpusDefault = currentBoard.tempData.arrpusDefault;
    allEventsFromResponse[currentBoard.loadedId] = eventsFromResponse;
    const additionalColumnsByFeatureName = currentBoard.additionalColumnsByFeatureName;
    const historyActivations = currentBoard.historyActivations;
    const events = currentBoard.events;
    const productIdColumns = additionalColumnsByFeatureName['product_id'];
    const productIdARPPUColumn = productIdColumns.find(({name}) => name === 'ARPPU');
    const summaryColumns = additionalColumnsByFeatureName['summary'];
    const summaryLTV365Column = summaryColumns.find(({name}) => name === 'pROMI');
    const tempDataByEvents = {};
    const eventsCountByDates = {};
    const compiledData = Object.assign(_.cloneDeep(arrpusDefault), productIdARPPUColumn.data);
    const rowNameFormat = getPrecisionFormat(currentBoard.precision);
    const expenseIndex = events.findIndex((e) => e.name === 'expense');
    const expenseData = eventsFromResponse[expenseIndex] || [];
    const arppuCoef = currentBoard.arppuCoef ? 0.85 : 0.7;
    Object.entries(historyActivations).forEach(([productIdName, summaryData]) => {
        const savedValue = compiledData[productIdName];
        const productIdARPPU = +(savedValue || 0);
        summaryData.forEach(({share, event, date}) => {
            if (!tempDataByEvents[event]) {
                tempDataByEvents[event] = {};
                const eventIndex = events.findIndex((e) => e.name === event);
                eventsCountByDates[event] = eventsFromResponse[eventIndex];
            }
            const eventData = tempDataByEvents[event];
            const dateFormatted = moment(date).format(rowNameFormat);
            if (!eventData[dateFormatted]) {
                eventData[dateFormatted] = 0;
            }
            const count = eventsCountByDates[event] ? eventsCountByDates[event].find((ev) => ev.Date === date).Count : 0;
            const currentValue = (share * productIdARPPU) * count * arppuCoef;
            eventData[dateFormatted] = roundNumber(eventData[dateFormatted] + currentValue);
        });
    });
    let totalBeforeCalculation = {};
    let total = {};
    Object.values(tempDataByEvents).forEach((eventObj, index) => {
        if (index === 0) {
            totalBeforeCalculation = _.cloneDeep(eventObj);
        } else {
            Object.entries(eventObj).forEach(([date, value]) => {
                totalBeforeCalculation[date] = roundNumber(totalBeforeCalculation[date] + value);
            });
        }
    });
    Object.entries(totalBeforeCalculation).forEach(([date, value]) => {
        let currentExpense = 0;
        if (expenseData.length) {
            currentExpense = expenseData.find((ex) => moment(ex.Date).format(rowNameFormat) === date).Count;
            total[date] = roundNumber(100 * (value - currentExpense) / currentExpense) || 0;
        } else {
            total[date] = '';
        }
    });
    summaryLTV365Column.data = total;
};

